// Module
var code = "<div class=\"w-[200px] h-[200px] md:w-[350px] md:h-[350px] overflow-hidden rounded-full\"> <img class=\"object-cover w-full h-full\" view=\"Image\" data-route=\"asset\" data-preset=\"[[ ( image.ext == 'svg' ) ? 'original' : preset ]]\" data-file_name=\"[[ image.file_name ]]\" data-ext=\"[[ image.ext ]]\"/> </div> ";
// Exports
export default code;